import dayjs from 'dayjs';
import type { RateInputs, FormRateInputs, InvestorType } from '../types/rates';
import { 
  validationConfig, 
  getMinimumDeferralPeriod as getMinDeferralPeriod,
  getMaximumDeferralPeriod as getMaxDeferralPeriod
} from './validationConfig';

// Default values configuration - undefined means no default
export const defaultValues: Partial<RateInputs> = {
  investorType: undefined,
  lifeInsuredGender: undefined,
  lifeInsuredAge: undefined,
  hasSpouse: undefined,
  spouseGender: undefined,
  spouseAge: undefined,
  agePensionPlus: undefined,
  paymentType: undefined,
  youngerSpouse: undefined
};

// Re-export validation config for backwards compatibility
export const validationValues = {
  ...validationConfig,
  investmentDateMax: dayjs().format('YYYY-MM-DD'),
};

// Shared function to get minimum deferral period based on investment date
export function getMinimumDeferralPeriod(investmentDate: string | undefined, investorType: InvestorType): number {
  return getMinDeferralPeriod(investmentDate || dayjs().format('YYYY-MM-DD'), investorType);
}

// Shared function to get maximum deferral period
export function getMaximumDeferralPeriod(lifeInsuredAge: number): number {
  return getMaxDeferralPeriod(lifeInsuredAge);
}

// Helper function to convert API defaults to form-safe defaults
export function getFormDefaults(apiDefaults: Partial<RateInputs> = defaultValues): Partial<FormRateInputs> {
  const defaultInvestmentDate = dayjs().format('YYYY-MM-DD')
  return {
    // Always provide controlled values - never undefined for form inputs
    investorType: apiDefaults.investorType ?? '',
    investmentDate: defaultInvestmentDate,
    lifeInsuredGender: apiDefaults.lifeInsuredGender || '',
    lifeInsuredAge: apiDefaults.lifeInsuredAge || 0,
    hasSpouse: apiDefaults.hasSpouse ?? '',
    spouseGender: apiDefaults.spouseGender || '',
    spouseAge: apiDefaults.spouseAge || 0,
    agePensionPlus: apiDefaults.agePensionPlus ?? '',
    paymentType: apiDefaults.paymentType || '',
    deferralPeriod: getMinimumDeferralPeriod(defaultInvestmentDate, apiDefaults.investorType || 'new'),
    youngerSpouse: apiDefaults.youngerSpouse || ''
  };
}